import apiClient from './api';

export interface MeituanOrderFulfillLog {
  id: string;
  serviceOrderId: string;
  serviceOrderNo: string;
  meituanOrderId: string;
  appOrderId: string;
  shopId: string;
  appAuthToken: string;
  orderFulfillStatus: number;
  requestPayload: string;
  responsePayload: string;
  status: string;
  errorMessage: string;
  fulfillmentSyncedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface MeituanOrderFulfillLogListParams {
  page?: number;
  pageSize?: number;
  serviceOrderNo?: string;
  serviceOrderId?: string;
  meituanOrderId?: string;
  appOrderId?: string;
  shopId?: string;
  orderFulfillStatus?: string;
  status?: string;
  startTime?: string;
  endTime?: string;
}

export const listMeituanOrderFulfillLogs = (params: MeituanOrderFulfillLogListParams) => (
  apiClient.get<{ list: MeituanOrderFulfillLog[]; total: number; page: number; pageSize: number }>(
    '/meituan/order-fulfill-logs',
    { params },
  )
);
